var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBundleAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Bundles/AWS@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 29,
    height: 29.1428571
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.055161909 29 0.055161909 23.0670117 4.85714286 6.09289309 4.85714286"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Bundles/AWS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64",
    transform: "translate(0, 4.8571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF9900",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.3575, 6.0709)",
    id: "amazon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5266495,5.66811277 C10.5266495,3.96377657 10.7454533,2.66709184 9.03288692,2.67142884 C9.03288692,2.67142884 7.43813853,2.67142884 6.75227026,4.81811251 L3.65955192,4.52321376 C3.65955192,2.38520408 5.62458507,0 9.32743152,0 C13.0218625,0 14.0527686,2.47193878 14.0527686,3.56913212 L14.0527686,9.94846912 C14.0527686,11.1410712 15.4118811,12.2382658 15.4118811,12.2382658 L13.0218625,14.6668373 C12.6052926,14.2635215 11.3892444,13.0795934 11.1157387,12.637246 C9.21382223,15.7076536 3.39446229,15.5125005 3.39446229,10.763776 C3.39446229,6.34030665 8.47746072,5.74617347 10.5266495,5.66811277 Z M10.5266495,7.67168407 C9.10862773,7.71938842 6.9836988,8.13137821 6.9836988,10.1783169 C6.9836988,12.3813776 10.5266495,12.9017857 10.5266495,9.43239796 L10.5266495,7.67168407 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.343821105,14.6885209 C3.42812401,16.6183679 8.24603217,19.7971939 16.0178024,16.002551 C16.333386,15.8420913 16.5774367,16.0892857 16.2492304,16.5229592 C15.9252308,16.9566327 13.3037843,19.4285714 8.90665416,19.4285714 C4.509524,19.4285714 1.14329932,16.3278061 0.112393203,15.0484694 C-0.17373597,14.7145403 0.154471003,14.5584189 0.343821105,14.6885209 Z M18.197432,14.7492363 C18.3531204,14.97041 18.197432,15.9244916 17.9239263,16.6183692 C17.6504206,17.3035714 17.2506815,17.7806122 17.0318764,17.9627556 C16.8004485,18.1579087 16.6321373,18.079848 16.7583707,17.7979602 C16.8846041,17.5160725 17.5704717,15.7813786 17.2927593,15.4127562 C17.0192536,15.0528077 15.7358807,15.2262771 15.2730249,15.2739801 C14.8185851,15.3173475 14.7260135,15.3607148 14.6839357,15.2609704 C14.5871572,15.013776 15.5970244,14.5887766 16.2618532,14.5020419 C16.9224752,14.4239812 17.987043,14.4673485 18.197432,14.7492363 Z",
    id: "Path-2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E88B00",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#AB6701",
    x: 13.2916667,
    y: 0,
    width: 2.41666667,
    height: 4.85714286
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.2,
    fill: "#000000",
    x: 13.2916667,
    y: 4.85714286,
    width: 2.41666667,
    height: 2.42857143
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundleAws);
export default __webpack_public_path__ + "static/media/BUNDLE_AWS.0bd96c9fd00378d430009fbda14886c4.svg";
export { ForwardRef as ReactComponent };